/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { type SelectOption } from '@dm/core/types';

import { actionE, syncStatusE } from './clone.const';

@Injectable({ providedIn: 'root' })
export class CloneStrService {
    table = {
        createBtn: this.get('common.create_button'),
        syncBtn: this.get('protection.replicationCG_sync_button'),
        startBtn: this.get('common.start_button1'),
        pauseBtn: this.get('protection.hyperMetroCG_term_pause_button'),
        resumeBtn: this.get('common.continue_button'),
        stopBtn: this.get('common.stop_button'),
        restoreBtn: this.get('common.reverseSync_button'),
        deleteBtn: this.get('common.delete_button'),
        startSyncBtn: this.get('common.startSyn_button'),
        pauseSyncBtn: this.get('common.pauseSyn_button'),
        resumeSyncBtn: this.get('common.continueSync_button'),
        stopSyncBtn: this.get('common.stopSync_button'),
        startRestoreBtn: this.get('common.startReverseSyn_button'),
        pauseRestoreBtn: this.get('common.pauseReverseSyn_button'),
        resumeRestoreBtn: this.get('common.continueReverseSyn_button'),
        stopRestoreBtn: this.get('common.stopReverseSyn_button'),
        modifyBtn: this.get('common.modify_button'),

        sourceLunNameLab: this.get('storage.smartMigration_term_sourceLunName_column'),
        targetLunNameLab: this.get('storage.smartMigration_term_targetLunName_column'),
        sourceLunLab: this.get('common.sourceLun_label'),
        targetLunLab: this.get('common.targetLun_label'),
        healthStatusLab: this.get('common.healthStatus_column'),
        runningStatusLab: this.get('common.runningStatus_column'),
        copyRateLab: this.get('protection.clone_term_copySpeed_column'),
        belongToCgLab: this.get('protection.clone_term_belongTo_cloneCG_column'),
        estimatedCopyEndTimeLab: this.get('protection.clone_task_estimateCopyEndTime_lab'),
        syncStartTimeLab: this.get('protection.replicationCG_term_syncStartTime_label'),
        syncEndTimeLab: this.get('protection.replicationCG_term_syncEndTime_label'),
        restoreStartTimeLab: this.get('protection.clone_task_reversesyncstartTime_label'),
        restoreEndTimeLab: this.get('protection.clone_task_reversesyncEndTime_label'),

        startSyncTips: this.get('protection.clone_task_startSync_tip'),
        pauseSyncTips: this.get('protection.clone_task_pauseSync_tip'),
        resumeSyncTips: this.get('protection.clone_task_continueSync_tip'),
        stopSyncTips: this.get('protection.clone_task_stopSync_tip'),
        startRestoreTips: this.get('protection.clone_task_startReverseSync_tip'),
        pauseRestoreTips: this.get('protection.clone_task_pauseReverseSync_tip'),
        resumeRestoreTips: this.get('protection.clone_task_continueReverseSync_tip'),
        stopRestoreTips: this.get('protection.clone_task_stopReverseSync_tip'),
    };

    create = {
        createVstoreSameInfo: this.get('protection.clone_task_create_vstoreSame_info'),
        targetPoolLab: this.get('protection.replicationCG_task_create_targetPool_lab'),
        vstoreLabel: this.get('common.owningVstore_lab'),
        winTitle: this.get('protection.clone_task_createClone_title'),

        specifyObjectLab: this.get('protection.protectionGroup_task_addMember_specifyObject_lab'),
        configurePairLab: this.get('protection.protectionGroup_task_addMember_configPair_lab'),
        confirmLab: this.get('common.confirm_lab'),

        avaiableLunLab: this.get('common.availableLun_column'),
        selectedLunLab: this.get('common.selectedLun_column'),
        nameLab: this.get('common.name_column'),
        wwn: this.get('storage.lun_view_summary_localWWN_label'),
        capacityLab: this.get('common.capacity_column'),
        pairCreationModeLab: this.get('protection.replicationCG_task_create_pairCreateMode_lab'),
        autoLab: this.get('common.EnumDefine_STARTUP_MODE_E_AUTO'),
        manualLab: this.get('common.EnumDefine_STARTUP_MODE_E_MANUAL'),
        pairListLab: this.get('common.clonePairs'),
        lunPairLab: this.get('common.lun_title'),
        copyRateLab: this.table.copyRateLab,
        syncImmediatelyLab: this.get('protection.clone_task_create_immediateSyn_lab'),
        sourceLunLab: this.get('common.sourceLun_label'),
        targetLunLab: this.get('common.targetLun_label'),
        selectedLuns: this.get('common.selectedLun_column'),
        selectedLun: this.get('common.selected', [this.get('common.objectType_LUN')]),
        sourceLunNameLab: this.table.sourceLunLab,
        targetLunNameLab: this.table.targetLunLab,
        yesLab: this.get('common.term_yes_label'),
        noLab: this.get('common.term_No_label'),

        selectOneObjectErr: this.get('common.selectOneObject_lab'),
        pairErr: this.get('protection.replicationCG_task_configPair_tip'),
        selectMaxObjectErr: this.get('common.selectedObjectNum_max_tip'),

        configureBtn: this.get('protection.replicationCG_task_create_remoteRepliPair_configure_lab'),
        modifyBtn: this.table.modifyBtn,
        nextBtn: this.get('common.next_button'),
        previousBtn: this.get('common.previous_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        closeBtn: this.get('common.close_button'),

        copyRateTip: this.get('protection.clone_task_create_copySpeed_valid_label'),
        filterDataTip: this.get('common.filterNoMeetData_tip'),

        vstoreNameLab: this.i18nService.get('vstore_name_lab'),
        vstoreIdLab: this.i18nService.get('vstore_id_lab'),
    };

    configurePair = {
        winTitle: this.get('protection.protectionGroup_task_addMember_configPair_lab'),

        nameLab: this.get('common.name_column'),
        capacityLab: this.get('common.capacity_column'),
        sourceLunLab: this.get('common.sourceLun_label'),
        sourceLunsLab: this.get('common.sourceLuns_label'),
        targetLunsLab: this.get('common.targetLuns_label'),
        targetLunLab: this.get('common.targetLun_label'),
        pairListLab: this.create.pairListLab,
        operationLab: this.get('common.operation_button'),

        addToPairListBtn: this.get('protection.replicationCG_task_configPair_addPairList_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        removeBtn: this.get('common.remove_button'),

        pairErr: this.create.pairErr,
    };

    modify = {
        winTitle: this.get('protection.clone_task_modifyClone_title'),

        copyRateLab: this.create.copyRateLab,
        descriptionLab: this.get('common.description_column'),

        okBtn: this.create.okBtn,
        cancelBtn: this.create.cancelBtn,

        copyRateTip: this.get('protection.clone_task_create_copySpeed_valid_label'),
    };

    detail = {
        vstoreLabel: this.get('common.owningVstore_lab'),
        sourceLunNameLab: this.table.sourceLunLab,
        targetLunNameLab: this.table.targetLunLab,
        healthStatusLab: this.table.healthStatusLab,
        runningStatusLab: this.table.runningStatusLab,
        copyRateLab: this.table.copyRateLab,
        belongToCgLab: this.table.belongToCgLab,
        estimatedCopyEndTimeLab: this.table.estimatedCopyEndTimeLab,
        syncStartTimeLab: this.table.syncStartTimeLab,
        syncEndTimeLab: this.table.syncEndTimeLab,
        restoreStartTimeLab: this.table.restoreStartTimeLab,
        restoreEndTimeLab: this.table.restoreEndTimeLab,
        descriptionLab: this.modify.descriptionLab,

        actionBtn: this.get('common.operation_button'),
        startSyncBtn: this.table.startSyncBtn,
        pauseSyncBtn: this.table.pauseSyncBtn,
        resumeSyncBtn: this.table.resumeSyncBtn,
        stopSyncBtn: this.table.stopSyncBtn,
        startRestoreBtn: this.table.startRestoreBtn,
        pauseRestoreBtn: this.table.pauseRestoreBtn,
        resumeRestoreBtn: this.table.resumeRestoreBtn,
        stopRestoreBtn: this.table.stopRestoreBtn,
        modifyBtn: this.table.modifyBtn,
        deleteBtn: this.table.deleteBtn,
        closeBtn: this.create.closeBtn,

        startSyncTips: this.table.startSyncTips,
        pauseSyncTips: this.table.pauseSyncTips,
        resumeSyncTips: this.table.resumeSyncTips,
        stopSyncTips: this.table.stopSyncTips,
        startRestoreTips: this.table.startRestoreTips,
        pauseRestoreTips: this.table.pauseRestoreTips,
        resumeRestoreTips: this.table.resumeRestoreTips,
        stopRestoreTips: this.table.stopRestoreTips,
    };

    delete = {
        winTitle: this.get('protection.clone_task_deleteClone_title'),
        deleteTips: this.get('protection.cloneConsistencyGroup_deleteClonePair_confirm_msg'),
        deleteTargetLunLab: this.get('protection.clone_term_deleteTargerLUN_column'),
        recycleDstLunData: this.get('protection.clone_term_reclaimTargerLUNData_checkbox'),
        sourceLunNameLab: this.table.sourceLunLab,
        targetLunNameLab: this.table.targetLunLab,
    };

    // 速率选项列表
    speedOptions: SelectOption[] = [
        {
            label: this.get('common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_LOW'),
            value: '1',
        },
        {
            label: this.get('common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_MIDDLE'),
            value: '2',
        },
        {
            label: this.get('common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_HIGH'),
            value: '3',
        },
        {
            label: this.get('common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_ASAP'),
            value: '4',
        },
    ];

    // 健康状态列表
    copyStatusOptions: SelectOption[] = [
        {
            label: this.get('common.EnumDefine_STATUS_E_NORMAL'),
            value: '0',
        },
        {
            label: this.get('common.EnumDefine_HEALTH_STATUS_fault'),
            value: '1',
        },
    ];

    // 运行状态列表
    syncStatusOptions: SelectOption[] = Object.keys(syncStatusE).map((k) => {
        const item = syncStatusE[k];
        return {
            label: this.get(item.i18n),
            value: item.value,
        };
    });

    sync = {
        startTips: this.get('protection.cloneConsistencyGroup_startSyncClonePair_confirm_msg'),
        stopTips: this.get('protection.cloneConsistencyGroup_stopClonePairSync_confirm_msg'),
    };

    restore = {
        copyTypeLab: this.get('protection.clone_term_reverseSynType_label'),
        startTips: this.get('protection.cloneConsistencyGroup_startClonePairReverseSync_confirm_msg'),
        stopTips: this.get('protection.cloneConsistencyGroup_stopClonePairReverseSync_confirm_msg'),

        sourceLunNameLab: this.table.sourceLunLab,
        targetLunNameLab: this.table.targetLunLab,
        okBtn: this.create.okBtn,
        cancelBtn: this.create.cancelBtn,
    };

    /**
     * 反向同步拷贝类型
     */
    copyTypeOptions: SelectOption[] = [
        {
            label: this.get('protection.clone_term_reverseSynType_Fullcopy_label'),
            value: '0',
        },
        {
            label: this.get('protection.clone_term_reverseSynType_Difcopy_label'),
            value: '1',
        },
    ];

    constructor(
        private i18nService: I18nService,
    ) { }

    get(key: string, params?: any[] | boolean, colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }

    /**
     * 长度范围错误
     * @param min
     * @param max
     */
    rangeByteLengthErr(min: number, max: number): string {
        return this.get('common.length_msg', [min, max]);
    }

    /**
     * 必填错误
     * @param name
     */
    requiredErr(name: string): string {
        return this.get('common.null_validation', [name]);
    }

    /**
     * 名称格式错误
     * @param name
     */
    commonNameErr(name: string): string {
        return this.get('common.nameformat_validation', [name]);
    }

    /**
     * 创建结果
     * @param sourceLunName
     * @param targetLunName
     */
    createResult(sourceLunName: string, targetLunName: string): string {
        return this.get('rest.create_clonePair_msg', [sourceLunName, targetLunName]);
    }

    /**
     * Pair数量显示
     */
    pairsNumLab = (num: number): string => this.get('common.numberOfPairs', [num]);

    /**
     * 删除结果
     * @param sourceLunName
     * @param targetLunName
     */
    deleteResult(sourceLunName: string, targetLunName: string): string {
        return this.get('rest.delete_clonePair_msg', [sourceLunName, targetLunName]);
    }

    /**
     * 同步标题
     * @param copyAction
     */
    syncTitle(copyAction: number): string {
        if (copyAction === actionE.start) {
            return this.get('protection.clone_task_startSynClone_title');
        }

        if (copyAction === actionE.stop) {
            return this.get('protection.clone_task_stopSynClone_title');
        }

        return '';
    }

    /**
     * 同步结果
     * @param sourceLunName
     * @param targetLunName
     */
    syncResult(copyAction: number, sourceLunName: string, targetLunName: string): string {
        if (copyAction === actionE.start) {
            return this.get('rest.startSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        if (copyAction === actionE.pause) {
            return this.get('rest.pauseSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        if (copyAction === actionE.resume) {
            return this.get('rest.continueSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        if (copyAction === actionE.stop) {
            return this.get('rest.stopSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        return '';
    }

    /**
     * 反向同步标题
     * @param copyAction
     */
    restoreTitle(copyAction: actionE): string {
        if (copyAction === actionE.start) {
            return this.get('protection.clone_task_revStartSynClone_title');
        }

        if (copyAction === actionE.stop) {
            return this.get('protection.clone_task_revStopSynClone_title');
        }

        return '';
    }

    /**
     * 反向同步结果
     * @param sourceLunName
     * @param targetLunName
     */
    restoreResult(copyAction: actionE, sourceLunName: string, targetLunName: string): string {
        if (copyAction === actionE.start) {
            return this.get('rest.startReverseSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        if (copyAction === actionE.pause) {
            return this.get('rest.pauseReverseSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        if (copyAction === actionE.resume) {
            return this.get('rest.continueReverseSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        if (copyAction === actionE.stop) {
            return this.get('rest.stopReverseSync_clonePair_msg', [sourceLunName, targetLunName]);
        }

        return '';
    }

    isEn(): boolean {
        return this.i18nService.language === 'en';
    }
}
